module.exports = __webpack_public_path__ + "202408221624/img/img_guide_share_322_196@2x.c986ac6e.png";